/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseRichTextBlockFragment} from '@amblique/contentful/app/contentful/fragments/rich-text-block/base-rich-text-block.fragment';
import {ImageFragment} from '@amblique/contentful/app/contentful/fragments/image/image.fragment';
import {VideoFragment} from '@amblique/contentful/app/contentful/fragments/video/video.fragment';

export const FullRichTextBlockFragment = gql`
  ${BaseRichTextBlockFragment}
  ${ImageFragment}
  ${VideoFragment}

  fragment FullRichTextBlockFragment on RichTextBlock {
    ...BaseRichTextBlockFragment

    image {
      ... on Image {
        ...ImageFragment
      }
      ... on Video {
        ...VideoFragment
      }
    }
  }
`;
